(function(){
  function onReady(fn){
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function(){
    /* ===== read asset URLs from data-* ===== */
    var dataEl = document.getElementById('wm-data') || {};
    var hoverUrl   = dataEl.dataset ? dataEl.dataset.hover : '';
    var clickUrl   = dataEl.dataset ? dataEl.dataset.click : '';
    var openCursor = dataEl.dataset ? dataEl.dataset.openCursor : '';
    var closedCursor = dataEl.dataset ? dataEl.dataset.closedCursor : '';

    /* ===== inject custom cursor CSS (keeps CSS file Liquid-free) ===== */
    if (openCursor && closedCursor){
      var css = `
        html, body { cursor: url(${openCursor}), auto; }
        html.cursor-down, body.cursor-down { cursor: url(${closedCursor}), auto !important; }
      `;
      var style = document.createElement('style');
      style.id = 'wm-cursors';
      style.textContent = css;
      document.head.appendChild(style);
    }

    /* ===== Background video + map-coordinate locking ===== */
    var v = document.getElementById('bgVideo');
    var mapLayer = document.querySelector('.wm-layer');

    if (v){
      var DESKTOP = v.dataset.desktop || '';
      var MOBILE  = v.dataset.mobile  || '';
      var POSTER  = v.dataset.poster  || '';
      
      function isDesktop(){
        return window.innerWidth > 999;
      }

      /*
        Make the hotspot layer represent the ACTUAL rendered video.

        object-fit: cover can make the video larger than the viewport
        and crop the excess. This calculates that larger rendered size
        so hotspot percentages stay attached to the artwork.
      */
      function syncMapToVideo(){
        if (!mapLayer || !v.videoWidth || !v.videoHeight) return;

        var box = v.getBoundingClientRect();

        var containerW = box.width;
        var containerH = box.height;

        var videoW = v.videoWidth;
        var videoH = v.videoHeight;

        var scale = Math.max(
          containerW / videoW,
          containerH / videoH
        );

        var renderedW = videoW * scale;
        var renderedH = videoH * scale;

        /*
          The video uses object-position: 50% 50%, so the rendered
          media is centred inside the video element.
        */
        var centerX = box.left + (containerW / 2);
        var centerY = box.top  + (containerH / 2);

        mapLayer.style.left   = centerX + 'px';
        mapLayer.style.top    = centerY + 'px';
        mapLayer.style.width  = renderedW + 'px';
        mapLayer.style.height = renderedH + 'px';
      }

      function setSource(){
        var desk = isDesktop();
        var src  = desk ? DESKTOP : MOBILE;

        if (src && v.src !== src){
          v.muted = true;
          v.setAttribute('playsinline', '');
          v.setAttribute('webkit-playsinline', '');
          v.autoplay = true;

          v.src = src;

          if (!desk && POSTER){
            v.poster = POSTER;
          } else {
            v.removeAttribute('poster');
          }

          v.preload = 'auto';
          v.load();

          v.play().catch(function(){});
        }
      }

      function tryPlay(){
        v.play().catch(function(){});
      }

      /*
        videoWidth/videoHeight become available here,
        so this is the important event for positioning.
      */
      v.addEventListener('loadedmetadata', function(){
        syncMapToVideo();
      });

      v.addEventListener('loadeddata', function(){
        syncMapToVideo();
      });

      v.addEventListener('canplay', function(){
        syncMapToVideo();
        tryPlay();
      }, { once:true });

      function handleResize(){
        var wasDesktop = isDesktop();

        setSource();

        requestAnimationFrame(function(){
          syncMapToVideo();
        });
      }

      window.addEventListener('resize', handleResize);
      window.addEventListener('orientationchange', handleResize);

      if (window.visualViewport){
        window.visualViewport.addEventListener('resize', function(){
          requestAnimationFrame(syncMapToVideo);
        });
      }

      setSource();

      /* Handles cached video metadata */
      if (v.readyState >= 1){
        syncMapToVideo();
      }
    }

    /* ===== Return arrow SFX (uses globals if present) ===== */
    var coarse = window.matchMedia('(hover: none), (pointer: coarse)');
    var back = document.querySelector('.wm-back');
    if (back){
      back.addEventListener('mouseenter', function(){
        if (!coarse.matches && window.playHover) window.playHover();
      });
      back.addEventListener('click', function(){
        if (window.playClick) window.playClick();
      });
    }

    /* ===== Local hover/click SFX for hotspots ===== */
    var hoverSfx = hoverUrl ? new Audio(hoverUrl) : null;
    var clickSfx = clickUrl ? new Audio(clickUrl) : null;
    if (hoverSfx){ hoverSfx.preload = 'auto'; hoverSfx.volume = 0.8; }
    if (clickSfx){ clickSfx.preload = 'auto'; clickSfx.volume = 0.9; }

    function playOnce(base, url){
      if (!base) return;
      try {
        if (!base.paused) {
          var clone = new Audio(url);
          clone.volume = base.volume;
          clone.play().catch(function(){});
        } else {
          base.currentTime = 0;
          base.play().catch(function(){});
        }
      } catch(e){}
    }

    /* ===== Panels & hotspots ===== */
    var spots    = document.querySelectorAll('.wm-hotspot');
    var panelsPC = document.querySelectorAll('.wm-panels-pc .wm-panel');
    var panelM   = document.querySelector('.wm-panel-m');

    function showPanelFor(index){
      if (coarse.matches){
        if (panelM){
          var box = panelM.querySelector('.wm-content');
          if (!box){
            box = document.createElement('div');
            box.className = 'wm-content';
            panelM.appendChild(box);
          }
          if (index === 0){
            box.innerHTML =
              '<h3 class="wm-title text-gold-outline">Shiganshina District</h3>' +
              '<p class="wm-body text-white">In the town where everything began, Eren Jaeger’s basement holds a truth that even he is not aware of. A truth born 2000 years ago. Uncover it, and humanity might break free from the titan’s century long tyranny.</p>';
          } else {
            box.innerHTML =
              '<h3 class="wm-title text-gold-outline wm-scramble-title">!=?#)$/&amp;$)</h3>' +
              '<p class="wm-body text-white wm-scramble-body">!=?#)$/&amp;$) []{} &lt;&gt; +=*^%~ |\\ :;,. 0192837465</p>';
            startScramble(box.querySelector('.wm-scramble-title'));
            startScramble(box.querySelector('.wm-scramble-body'));
          }
          panelM.classList.add('is-visible');
        }
      } else {
        panelsPC.forEach(function(p, i){
          p.classList.toggle('is-visible', i === index);
        });
      }
    }

    function hidePanels(){
      panelsPC.forEach(function(p){ p.classList.remove('is-visible'); });
      if (panelM) panelM.classList.remove('is-visible');
    }

    function clearActive(){ spots.forEach(function(b){ b.classList.remove('is-active'); }); }

    spots.forEach(function(btn, idx){
      if (coarse.matches){
        btn.addEventListener('touchend', function(e){
          e.preventDefault();
          clearActive();
          btn.classList.add('is-active');
          showPanelFor(idx);
          playOnce(clickSfx, clickUrl);
        }, { passive: false });
      } else {
        btn.addEventListener('mouseenter', function(){
          showPanelFor(idx);
          playOnce(hoverSfx, hoverUrl);
        });
        btn.addEventListener('mouseleave', hidePanels);
        btn.addEventListener('focus',   function(){ showPanelFor(idx); });
        btn.addEventListener('blur',    hidePanels);
        btn.addEventListener('click',   function(){ playOnce(clickSfx, clickUrl); });
      }
    });

    document.addEventListener('click', function(e){
      if (coarse.matches && !e.target.closest('.wm-hotspot')){
        clearActive();
        hidePanels();
      }
    });

    /* ===== Scramble effect ===== */
    var WM_CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!?#$%&*/+=-<>^~|\\[]{}():;,.';

    function startScramble(el){
      if (!el || el.dataset.scrambling) return;
      el.dataset.scrambling = '1';
      var chars = Array.from(el.textContent);
      var targets = [];
      for (var i = 0; i < chars.length; i++){
        if (!/\s/.test(chars[i])) targets.push(i);
      }
      function tickOne(i){
        if (!el.isConnected) return;
        var panel = el.closest('.wm-panel');
        var run = !panel || panel.classList.contains('is-visible') || panel.classList.contains('wm-panel-m');
        if (run){
          chars[i] = WM_CHARSET[(Math.random() * WM_CHARSET.length) | 0];
          el.textContent = chars.join('');
        }
        setTimeout(function(){ tickOne(i); }, 300 + Math.random() * 400);
      }
      targets.forEach(function(i){
        setTimeout(function(){ tickOne(i); }, Math.random() * 500);
      });
    }

    document
      .querySelectorAll('.wm-panels-pc .wm-scramble-title, .wm-panels-pc .wm-scramble-body')
      .forEach(startScramble);

    /* ===== Cursor press/release toggles ===== */
    function press() {
      document.documentElement.classList.add('cursor-down');
      document.body.classList.add('cursor-down');
    }
    function release() {
      document.documentElement.classList.remove('cursor-down');
      document.body.classList.remove('cursor-down');
    }
    window.addEventListener('mousedown', press);
    window.addEventListener('mouseup', release);
    window.addEventListener('mouseleave', release);
    window.addEventListener('touchstart', press, { passive:true });
    window.addEventListener('touchend', release, { passive:true });
    window.addEventListener('touchcancel', release, { passive:true });
  });
})();